/**
 * Restructures flat RTE content into polished alternating image+text rows.
 * Pairs each image with adjacent text elements, alternating left/right placement.
 */
(function () {
  var rteContainers = document.querySelectorAll('.main-page-section .rte');

  rteContainers.forEach(function (rte) {
    var children = Array.from(rte.children);
    if (children.length === 0) return;

    var hasAnyImages = rte.querySelector('img');
    if (!hasAnyImages) {
      rte.style.opacity = '1';
      return;
    }

    // Classify each child as 'text' or 'image'
    var items = [];
    children.forEach(function (el) {
      var img = el.tagName.toLowerCase() === 'img' ? el : el.querySelector('img');
      if (img) {
        items.push({ type: 'image', element: el, img: img });
      } else {
        items.push({ type: 'text', element: el });
      }
    });

    // Pair text blocks with images into rows
    var rows = [];
    var textBuffer = [];
    var pendingImage = null;

    items.forEach(function (item) {
      if (item.type === 'text') {
        if (pendingImage) {
          // Image was waiting for text — pair them
          rows.push({ texts: [item.element], image: pendingImage });
          pendingImage = null;
        } else {
          textBuffer.push(item.element);
        }
      } else {
        // Image element
        if (textBuffer.length > 0) {
          // Pair accumulated text with this image
          rows.push({ texts: textBuffer, image: item });
          textBuffer = [];
        } else {
          // No text available — flush any pending image as its own row
          if (pendingImage) {
            rows.push({ texts: [], image: pendingImage });
          }
          pendingImage = item;
        }
      }
    });

    // Handle leftovers
    if (pendingImage && textBuffer.length > 0) {
      rows.push({ texts: textBuffer, image: pendingImage });
    } else {
      if (pendingImage) {
        rows.push({ texts: [], image: pendingImage });
      }
      if (textBuffer.length > 0) {
        rows.push({ texts: textBuffer, image: null });
      }
    }

    // Render rows
    rte.innerHTML = '';
    var imageRowIndex = 0;

    rows.forEach(function (rowData) {
      var row = document.createElement('div');
      row.className = 'rte-row';

      var textWrapper = document.createElement('div');
      textWrapper.className = 'rte-row__text';

      rowData.texts.forEach(function (el) {
        textWrapper.appendChild(el);
      });

      if (rowData.image) {
        var imageWrapper = document.createElement('div');
        imageWrapper.className = 'rte-row__image';
        var img = rowData.image.img;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.removeAttribute('width');
        img.removeAttribute('height');
        imageWrapper.appendChild(rowData.image.element);

        row.classList.add('rte-row--with-image');
        if (imageRowIndex % 2 === 1) {
          row.classList.add('rte-row--reverse');
        }
        row.appendChild(textWrapper);
        row.appendChild(imageWrapper);
        imageRowIndex++;
      } else {
        row.classList.add('rte-row--text-only');
        row.appendChild(textWrapper);
      }

      rte.appendChild(row);
    });

    // Reveal content after restructuring
    rte.style.opacity = '1';
  });
})();
